// @flow

import React, { type Node } from 'react';
import { Stack } from './stack';

type Props = {
  /**
   * The content of the component.
   */
  children?: Node,
  /**
   * Add an element between each child.
   */
  divider?: React$Element<any>,
  /**
   * Sets justify-content flexbox CSS value
   */
  justify?:
    | 'flex-start'
    | 'center'
    | 'flex-end'
    | 'space-between'
    | 'space-around'
    | 'space-evenly',
};

const DEFAULT_JUSTIFY = 'flex-start';
const DEFAULT_SPACING = 1;

const CompactRow = ({ children, divider, justify }: Props) => {
  return (
    <Stack
      direction="row"
      divider={divider}
      spacing={DEFAULT_SPACING}
      justify={justify || DEFAULT_JUSTIFY}
      alignItems="center"
    >
      {children}
    </Stack>
  );
};

export { CompactRow };
